import { useLocation, useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import styled from 'styled-components';

import Cart from '../../../assets/imgs/icon/basket.svg?react';
import Home from '../../../assets/imgs/icon/home.svg?react';
import Person from '../../../assets/imgs/icon/person.svg?react';
import QrCode from '../../../assets/imgs/icon/qrcode.svg?react';
import { cartQuantityState } from '../../../Cart/atoms';
import { Flex } from '../../../GlobalComponents/Flex';
import { IconButton } from '../../../GlobalComponents/IconButton';
import { SideDrawer } from '../../../Header/components/SideDrawer';
import { useAppSelector } from '../../../reduxstore/hooks';

export const BottomNavBar: React.FC = () => {
	const navigate = useNavigate();
	const { pathname } = useLocation();
	const cartQuantity = useRecoilValue(cartQuantityState);
	const isAuthenticated = useAppSelector(
		state => state.authReducer.accessToken
	);

	return (
		<>
			<Container>
				<Flex
					$flexDirection="row"
					$alignItems="center"
					$placeContent="center space-between"
					$width="auto"
				>
					<NavButton onClick={() => navigate('/menu')}>
						<NavIcon
							svg={<Home />}
							alt={'HOME'}
							active={pathname.includes('menu')}
						/>
						<Label>Home</Label>
					</NavButton>
					<NavButton onClick={() => navigate('/scan')}>
						<NavIcon
							svg={<QrCode />}
							alt={'QR'}
							active={pathname.includes('scan')}
						/>

						<Label>Scan</Label>
					</NavButton>
					<NavButton onClick={() => navigate('/cart')}>
						<CartContainer>
							<NavIcon
								svg={<Cart />}
								alt={'Cart'}
								active={
									pathname.includes('cart') ||
									pathname.includes('checkout')
								}
							/>
							{cartQuantity > 0 && (
								<CartQuantity>
									<Quantity>{cartQuantity}</Quantity>
								</CartQuantity>
							)}
						</CartContainer>
						<Label>Cart</Label>
					</NavButton>

					<NavButton
						onClick={() =>
							isAuthenticated
								? navigate('/account/rewards')
								: navigate('/login?redirect=/account/rewards')
						}
					>
						<NavIcon
							svg={<Person />}
							alt={'dashboard'}
							active={
								pathname.includes('dashboard') ||
								pathname.includes('rewards')
							}
						/>
						<Label>Rewards</Label>
					</NavButton>

					<NavButton>
						<SideDrawer />
						<Label>Menu</Label>
					</NavButton>
				</Flex>
			</Container>
		</>
	);
};

const CartContainer = styled.div`
	position: relative;
	display: inline-block;
`;

const Quantity = styled.span`
	font-size: 14px;
	color: white;
	font-weight: bold;
`;

const Container = styled.div`
	position: fixed;
	left: 0;
	bottom: 0;
	width: 100%;
	background-color: #f5f2f2;
	z-index: 999;
	box-shadow: 0 1px 2px 2px rgba(0, 0, 0, 0.1);
	padding: 24px 16px 32px 16px;
	height: 90px;
`;

const NavButton = styled.div`
	width: 40px;
	height: 52px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	row-gap: 8px;
`;

const NavIcon = styled(IconButton)``;

const Label = styled.p`
	font-size: 14px;
	line-height: 100%;
	margin: 0;
	padding: 0;
	overflow: hidden;
	white-space: nowrap;
`;

const CartQuantity = styled.div`
	position: absolute;
	top: -9px;
	right: -6px;
	width: 20px;
	height: 20px;
	border-radius: 50%;
	background-color: #f47920;
	display: flex;
	justify-content: center;
	align-items: center;
`;
